export const statusList = [
  {
    key: 'TOTAL',
    label: 'Total'
  },
  {
    key: 'SCHEDULED',
    label: 'Scheduled'
  },
  {
    key: 'ON_GROUND',
    label: 'On-Ground'
  },
  {
    key: 'IN_FLIGHT',
    label: 'In-Flight'
  },
  {
    key: 'COMPLETED',
    label: 'Completed'
  },
  {
    key: 'CANCELLED',
    label: 'Cancelled'
  },
  {
    key: 'DELAYED',
    label: 'Delayed'
  },
];
export const sortByOptions = [
  {
    id: 'lastActivityUpdatedAt',
    name: 'Last Activity Updated',
  },
  {
    id: 'lastSuccessfulTrackingStatusUpdatedAt',
    name: 'Last Tracking Time',
  },
  {
    id: 'updatedAt',
    name: 'Date of Creation',
  },
  {
    id: 'completionDate',
    name: 'Date of Completion',
  },
];
export const statusColorMap = {
  DELAYED: '#FFE763',
  COMPLETED: '#A0E877',
  CANCELLED: '#FFAEAC',
  IN_FLIGHT: '#A5DD94',
  ON_GROUND: '#C9BF6D',
  SCHEDULED: '#D8F3FE',
  UNAVAILABLE: '#FFCC8A',
};
export const statusMap = {
  SCHEDULED: 'Scheduled',
  ON_GROUND: 'On-Ground',
  IN_FLIGHT: 'In-Flight',
  CANCELLED: 'Cancelled',
  COMPLETED: 'Completed',
  DELAYED: 'Delayed',
  UNAVAILABLE: 'Unavailable',
  ARRIVED: 'Arrived',
};
export const accessIconMap = {
  PUBLIC: {
    icon: 'global',
    name: 'Public',
  },
  WORKPLACE: {
    icon: 'global',
    name: 'Public',
  },
  TEAM: {
    icon: 'team',
    name: 'Team',
  },
  PRIVATE: {
    icon: 'user',
    name: 'Private',
  },
}
export const movementTypeOptions = [
  {label: 'Export', value: 'EXPORT'},
  {label: 'Import', value: 'IMPORT'},
  {label: 'Internal Movement', value: 'INTERNAL_MOVEMENT'},
];

export const isTestData = [
  {label: 'No', value: 'false'},
  {label: 'Yes', value: 'true'},
];

export const flightStatusColorMap = {
  IN_FLIGHT: '#E9F8E5',
  ARRIVED: '#E8F1FD',
  SCHEDULED: '#D8F3FE',
}
export enum AirCargoStatusCodes {
  RCS = 'RCS',
  DEP = 'DEP',
  ARR = 'ARR',
  NFD = 'NFD',
  DLV = 'DLV',
};

export enum HAWBDateFilter {
  flight_date = 'Date of Flight',
  created_at = 'Date of Creation',
  completion_date = 'Date of Completion',
}